/**
 * Rules for a task's model settings that both the admin page and the API need. Kept free of
 * server-only imports so the client component can use them.
 */
import type { CatalogModel } from "@/lib/llm-models/catalog";

/** The highest `max_output_tokens` the workers accept; they ignore anything above it. */
export const MAX_OUTPUT_TOKENS_LIMIT = 128_000;

/**
 * Tasks whose replies inara validates as JSON. On a model with neither a strict schema
 * (`structured_outputs`) nor JSON mode (`response_format`) their replies fail more often.
 */
export const JSON_TASKS: readonly string[] = [
  "translate_lesson",
  "translate_quiz",
  "translate_placement_quiz",
  "generate_quiz",
  "generate_placement_quiz",
];

export function lacksJsonSupportForTask(task: string, model: Pick<CatalogModel, "supportsJsonSchema" | "supportsJsonMode">): boolean {
  return JSON_TASKS.includes(task) && !model.supportsJsonSchema && !model.supportsJsonMode;
}

/** The highest output cap a task may have on this model: the workers' limit or the model's own, whichever is lower. */
export function outputTokenCeiling(model: Pick<CatalogModel, "maxCompletionTokens">): number {
  return model.maxCompletionTokens ? Math.min(model.maxCompletionTokens, MAX_OUTPUT_TOKENS_LIMIT) : MAX_OUTPUT_TOKENS_LIMIT;
}

/** What one call of a task could cost at most: its output-token cap at the model's output price. */
export function worstCaseCostUsd(maxOutputTokens: number, model: Pick<CatalogModel, "outputPerToken">): number {
  return maxOutputTokens * model.outputPerToken;
}
